module.exports = __webpack_public_path__ + "static/media/ico_flacidez.88771f24.svg";